import { render, staticRenderFns } from "./GuestItem.vue?vue&type=template&id=3a07508f&"
import script from "./GuestItem.vue?vue&type=script&lang=ts&"
export * from "./GuestItem.vue?vue&type=script&lang=ts&"
import style0 from "./GuestItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports